import React from 'react';
import { Grid } from '@mui/material';
import { Company } from '../../../models/company.model';
import DocumentListVault from '../../document-vault/components/document-list-vault/DocumentListVault';
import { BusinessCategoryContent } from './BusinessCategoryContent';
import { ProgressOverlay } from '../../../common/progress-overlay/ProgressOverlay';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { RootState } from '../../../store';
import DocumentsBlock, {
  DocumentsActionsProps,
} from '../../../common/documents-block/DocumentsBlock';

interface DocumentsTabsProps {
  company: Company;
  documents: any[];
  key: string;
  cardView?: boolean;
  workflow: string | null;
  setWorkflow: React.SetStateAction<any>;
  showWorkflowBreadcrumbs: boolean;
  setShowWorkflowBreadcrumbs: React.SetStateAction<any>;
  /** Pagination + card / list switcher, attached to the documents table / workflow cards. */
  documentsActions?: DocumentsActionsProps;
}

const DocumentsTabs: React.FC<DocumentsTabsProps> = ({
  documents,
  cardView,
  workflow,
  setWorkflow,
  setShowWorkflowBreadcrumbs,
  showWorkflowBreadcrumbs,
  documentsActions,
}) => {
  // useEffect(() => {
  //   const fetchAllDocuments = async () => {
  //     // For every member, dispatch both actions and wait for both results
  //     const results = await Promise.all(
  //       company.members.map(async (member) => {
  //         console.log('Member:', member);
  //         const [docsAction, contractsAction] = await Promise.all([
  //           dispatch(fetchDocuments({ data: { user: member.id, category: 'business' } })),
  //           dispatch(fetchDocumentContracts({ data: { user: member.id, category: 'business' } })),
  //         ]);
  //         // Assuming the payloads contain the resulting documents/objects
  //         return [
  //           ...(Array.isArray(docsAction.payload) ? docsAction.payload : []),
  //           ...(Array.isArray(contractsAction.payload) ? contractsAction.payload : []),
  //         ];
  //       })
  //     );
  //     // Flatten the result and update the documents state
  //     setDocuments(results.flat());
  //   };

  //   fetchAllDocuments();
  // }, [company.members, dispatch]);

  const documentUploadsLoading = useAppSelector((state: RootState) => state.documents.status);

  return (
    <Grid component='div' container wrap='nowrap'>
      <Grid component='div' size={{ xs: 12 }} style={{ position: 'relative' }}>
        {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <FilterDrawer sections={filterSections} onApplyFilters={handleApplyFilters} />
        </Box> */}
        {cardView ? (
          <BusinessCategoryContent
            documents={documents}
            cardView={cardView}
            documentsActions={documentsActions}
            workflow={workflow}
            setWorkflow={setWorkflow}
            setShowWorkflowBreadcrumbs={setShowWorkflowBreadcrumbs}
            showWorkflowBreadcrumbs={showWorkflowBreadcrumbs}
          />
        ) : (
          <DocumentsBlock actions={documentsActions}>
            <DocumentListVault documents={documents} compact embedded={!!documentsActions} />
            {documentUploadsLoading === 'loading' && <ProgressOverlay position='absolute' />}
          </DocumentsBlock>
        )}
      </Grid>
    </Grid>
  );
};

export default DocumentsTabs;
